export interface ImportSummaryInput {
  selectedCount: number;
  added: number;
  skipped: number;
  limitExceeded?: boolean;
}

export interface ImportSummary {
  duplicateCount: number;
  allDuplicates: boolean;
  mixedAddedAndDuplicates: boolean;
}

export const summarizeImportOutcome = (input: ImportSummaryInput): ImportSummary => {
  const duplicateCount = Math.max(0, input.selectedCount - input.added - input.skipped);
  return {
    duplicateCount,
    allDuplicates: !input.limitExceeded && input.added === 0 && duplicateCount > 0,
    mixedAddedAndDuplicates: !input.limitExceeded && input.added > 0 && duplicateCount > 0,
  };
};
